import React, { useEffect, useState } from 'react'
import CataloghiTemplate from '../../components/template/CataloghiTemplate/CataloghiTemplate'
import MaterialePromozionaleTemplate from '../../components/template/MaterialePromozionaleTemplate/MaterialePromozionaleTemplate'
import Error from 'next/error'
import { PAGINEDETAIL, CATALOGHI, CATEGORIEMATERIALEPROMOZIONALE } from '../../utils/endpoint'
import { getApiClient } from '../../utils'
import { Breadcrumbs, MetaSeo } from '../../components/index'
import PropTypes from 'prop-types'
import CatalogoPersonalizzatoTemplate from '../../components/template/CatalogoPersonalizzatoTemplate/CatalogoPersonalizzatoTemplate'
import { useSelector } from 'react-redux'
import ModalLogin from '../../components/organisms/ModalLogin/ModalLogin'
import { useRouter } from 'next/router'

const Cataloghi = ({ page, statusCode, cataloghi, materialePromozionale }) => {
  if (!page) return <Error statusCode={statusCode} />
  const { utente, fetched, error } = useSelector((state) => state.utente)
  const [popupLogin, setPopupLogin] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const router = useRouter()
  const { service_gift } = useSelector((state) => state?.servicegift)

  const HandleClick = () => {
    if (!utente) {
      setPopupLogin(true)
      setRedirect(true)
    }
  }

  return (
    <>
      <MetaSeo seo={page.seo} />
      <div className="page">
        <div className="w-container">
          <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        </div>
        <CataloghiTemplate cataloghi={cataloghi} />
        {utente && <MaterialePromozionaleTemplate materialePromozionale={materialePromozionale} />}
        {!service_gift && (
          <CatalogoPersonalizzatoTemplate
            page={page}
            utente={utente}
            onClick={() => HandleClick()}
          />
        )}
        <div style={{ position: 'absolute' }}>
          <ModalLogin
            withRedirect={true}
            url={`${router.locale}/richiesta-catalogo`}
            visible={popupLogin}
            onClose={() => setPopupLogin(false)}
          />
        </div>
      </div>
    </>
  )
}

export async function getServerSideProps({ params, locale, query, req }) {
  const api = getApiClient(req)
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: { chiave: 'cataloghi', lang: locale },
  })
  const cataloghiResponse = await api.get(CATALOGHI, { params: { lang: locale } })
  const materialePromozionaleResponse = await api.get(CATEGORIEMATERIALEPROMOZIONALE, {
    params: { lang: locale },
  })
  const page = await pageResponse.data
  const cataloghi = await cataloghiResponse.data
  const materialePromozionale = await materialePromozionaleResponse.data

  const toolbarProps = { toolbarPage: page }
  return {
    props: { page, ...toolbarProps, cataloghi, materialePromozionale },
  }
}

Cataloghi.propTypes = {
  page: PropTypes.object,
  statusCode: PropTypes.number,
  i18n: PropTypes.object,
  t: PropTypes.func,
}

export default Cataloghi
